if(!customElements.get('bundle-builder')) {
  class BundleBuilder extends HTMLElement {
  	constructor() {
      super();

      var config = {
        bundleContainer: this, //bundle box selector
        items: document.querySelectorAll(this.dataset.itemsSelector), //items selector,
        bundleMinItems: parseInt(this.dataset.bundleMinItems), //global minimum required quantity of items in the bundle
        bundleMaxItems: parseInt(this.dataset.bundleMaxItems), //global limit of items in the bundle, 0=no limit
        groupItems: this.dataset.groupItems=='true', // true, or false to view 1 unit item,
        cartBundleMode: this.dataset.cartBundleMode, // "grouped" or "individual",
        showItemsPlaceholder: this.dataset.showItemsPlaceholder=='true',
        stepsContainer: document.querySelector(this.dataset.stepsContainerSelector)
      }
      //nav & panels behavior
      var btnNavClickHandler = ()=>{};
      if (config.stepsContainer.dataset.navMode == 'step_by_step' || config.stepsContainer.dataset.navMode == 'show_tabs') {
        btnNavClickHandler = function() {
          var switchPanel = true;
          var oldActiveButton = config.stepsContainer.querySelector('.step-nav.active');
          var oldActiveStep = oldActiveButton.dataset.step/1;
          var newStep = this.dataset.step/1;
          if (this.classList.contains('active')) {
            //don't switch if it is the active panel;
            switchPanel = false;
          }
          if (switchPanel) {
            var oldActivePanel = config.stepsContainer.querySelector('.step.active');
            var newActivePanel = config.stepsContainer.querySelector('.step[data-step="'+newStep+'"]');
            oldActiveButton.classList.remove('active');
            oldActivePanel.classList.remove('active');
            this.classList.add('active');
            newActivePanel.classList.add('active');

          }
        }
      } else {
        btnNavClickHandler = function() {
          var newStep = this.dataset.step/1;
          var newActivePanel = config.stepsContainer.querySelector('.step[data-step="'+newStep+'"]');
          $s.scrollToElement(newActivePanel, 60);
        }
      }
      config.stepsContainer.querySelectorAll('.nav .step-nav').forEach(function(btn) {
        btn.addEventListener('click', btnNavClickHandler)
      });

      /* start of builder */
      var Bundler = (function(config) {
        var self = {};
        var container = config.bundleContainer;
        self.dataJson = JSON.parse(container.querySelector('[type="application/json"]').textContent);
        self.stats = {count: 0, total: 0, discount_code: '', incomplete_products_steps: self.dataJson.products_steps.map((x,key)=>key).filter(x=>x>0)};


        var itemsAdded = [];
        var uniqIndex = 1;
        var uniq = function() {
          return 'k-' + uniqIndex++;
        }
        var variantUnits = function(id, currentStep) {
          return itemsAdded.reduce((x,y)=>x + (id == y.variant_id && currentStep == y.step  ? y.quantity : 0), 0);
        }
        var productUnits = function(id, currentStep) {
          return itemsAdded.reduce((x,y)=>x + (id == y.product_id && currentStep == y.step ? y.quantity : 0), 0);
        }
        self.add = function(variantId, quantity, htmlItem) {
          var index = itemsAdded.map((x)=>x.variant_id).lastIndexOf(variantId);
          var item;
          if (config.groupItems && index != -1) {
            item = itemsAdded[index];
            item.quantity += quantity
          } else {
            var json = JSON.parse(htmlItem.querySelector('[type="application/json"][data-product-json]').textContent);
            item = {
              variant_id: variantId,
              quantity: quantity,
              key: uniq(),
              product_id: htmlItem.dataset.productId,
              title: htmlItem.querySelector('.title').innerText,
              image: htmlItem.querySelector('.img.main').outerHTML,
              variant: json.variants.find((x)=>x.id==variantId),
              productData: json,
              step: htmlItem.step
            };
            itemsAdded.push(item);
          }
          self.drawItem(item);
          
        }
        self.remove = function(variantId, removeQuantity, currentStep) {
          var index = itemsAdded.map((x)=>{return currentStep==x.step ? x.variant_id : 0}).lastIndexOf(variantId);
          self.removeByIndex(index, removeQuantity);
        }
        self.removeByKey = function(key) {
          var index = itemsAdded.findIndex((x)=>x.key==key);
          var item = itemsAdded[index];
          self.removeByIndex(index, item.quantity);
        }
        self.removeByIndex = function(index, removeQuantity) {
          var item = itemsAdded[index];
          item.quantity -= removeQuantity;
          if (item.quantity == 0) {
            itemsAdded.splice(index, 1);
          }
          self.drawItem(item);
        }
        self.drawItem = function(item) {
          var itemsContainer = container.querySelector('.bundle-items');
          var html = `
            <div class="bundle-item grid-item" data-key="${item.key}">
              <div class="grid direction-column">
                <div class="grid-item one-whole">
                  <div class="image">${item.image}</div>
                </div>
                <div class="grid-item one-whole">
                  <div class="title">${item.title}</div>
                  <div class="variant-title">${item.variant.title}</div>
                  <div class="flex justify-content-between align-items-center">
                    <div class="flex price-quantity-wrapper">
                      <div class="price"><span class="money">` + $s.formatMoney(item.variant.price) + `</span></div>
                    </div>
                    <button class="remove" aria-label="Remove Item" title="Remove Item">
                      <svg aria-hidden="true" tabindex="-1" role="presentation" class="icon icon-close" viewBox="0 0 32 32"><path fill="" d="M17.825,16l10.208,10.207l-1.827,1.826L16,17.824L5.793,28.033l-1.826-1.826L14.174,16L3.967,5.793l1.826-1.826L16,14.174 L26.208,3.967l1.825,1.826L17.825,16z"></path></svg>
                    </button>
                  </div>
                  <div class="full-details"><a href="${item.productData.src}">View Full Details</a></div>
                </div>
              </div>
            </div>
            `;
            console.log(item)
          var existingItem = itemsContainer.querySelector('[data-key="' + item.key + '"]');
          if (item.quantity == 0) {
            html = '';
          }
          if (existingItem) {
            existingItem.outerHTML = html;
          } else {
            itemsContainer.insertAdjacentHTML("beforeend", html);
            
          }
          if (html != '') {
            itemsContainer.querySelector('.bundle-item[data-key="' + item.key + '"] .remove').addEventListener('click', function() {
              self.removeByKey(item.key);
            });
          }

          self.updateUI(item.step);
        }
        self.drawFormInputs = function() {
          //TODO Subscription updates here (replace variant_id, set subscription properties or selling plan value)
          var html = ''
          var bundleId = new Date().getTime() + '-' + Math.floor(Math.random()*9999 + 1000);

          //walk array in reverse order (then cart items order will match what user see in the bundler builder)
          for (var index = itemsAdded.length -1; index>=0; index--) {
            var item = itemsAdded[index];
            var mode = config.cartBundleMode == 'grouped' ? (index==0?'main' : 'related_multiple') : 'individual';
            html += `
              <input type="hidden" name="items[${index}][id]" value="${item.variant_id}">
              <input type="hidden" name="items[${index}][properties[_bundle_id]]" value="${bundleId}">
              <input type="hidden" name="items[${index}][properties[_bundle_item]]" value="${mode}">
              <input type="hidden" name="items[${index}][properties[_bundle_type]]" value="bundle_builder">
              <input type="hidden" name="items[${index}][quantity]" value="${item.quantity}">
              <input type="hidden" name="items[${index}][properties[_bundle_offer]]" value="1">
              `;
              if (config.cartBundleMode == 'grouped') {
                html += `
                <input type="hidden" name="items[${index}][properties[_locked]]" value="quantity">
                  `;
              }
              if (!config.groupItems) {
              html += `
                <input type="hidden" name="items[${index}][properties[_bundle_position]]" value="${index + 1}">
                `;
            }
          }
          container.querySelector('.form-inputs').innerHTML = html;
        }
        self.updateUI = function(currentStep) {
          //TODO Subscription updates here (show discounted price, don't change the variant id)
          var itemsContainer = container.querySelector('.bundle-items');
          var totalCount = itemsAdded.reduce((x,y)=>x + y.quantity, 0);
          var totalPrice = itemsAdded.reduce((x,y)=>x + y.variant.price * y.quantity, 0);
          self.stats.count = totalCount;
          self.stats.total = totalPrice;
          self.stats.discounted_price = '';


          self.dataJson.products_steps.forEach(function(pd_step, stepIx) {
            var currentStep = stepIx + 1;
            var stepConfig = self.dataJson.products_steps[stepIx];
            var stepContainter = config.stepsContainer.querySelector('.step[data-step="'+currentStep+'"]')
            var itemsAddedFromStep = itemsAdded.filter(x=>x.step==currentStep);
            var totalCountInStep = itemsAddedFromStep.reduce((x,y)=>x + y.quantity, 0);
            if (stepContainter) {
              stepContainter.querySelectorAll('.selected-quantity').forEach(x=>x.innerHTML = totalCountInStep);
            }

            var incompleteStepsItemIndex = self.stats.incomplete_products_steps.indexOf(currentStep);
            if (stepConfig.min_items > 0 && totalCountInStep < stepConfig.min_items) {
              if (incompleteStepsItemIndex==-1) {
                self.stats.incomplete_products_steps.push(currentStep);
              }
            } else if (incompleteStepsItemIndex > -1) {
              self.stats.incomplete_products_steps.splice(incompleteStepsItemIndex, 1);
            }

            config.items.forEach(function(item) {
              if (item.step!=currentStep) {
                return;
              }
              //update number in quantity box (useful when removing items with the X)
              var currentVariantId = item.querySelector('[data-variant-id]').value;
              var currentVariantUnits = variantUnits(currentVariantId, currentStep);
              item.querySelector('input[type="number"]').value = currentVariantUnits;

              //disable/enable MINUS button
              item.querySelectorAll('.quantity-button.minus').forEach(function(element) {
                if (item.querySelector('[type="number"]').value == 0) {
                  element.setAttribute('disabled', true);
                } else {
                  element.removeAttribute('disabled');
                }
              });
              
              //disable/enable PLUS and ADD buttons
              item.querySelectorAll('.quantity-button.plus, .btn.add').forEach(function(element) {
                var variantInput = item.querySelector('[data-variant-id]')
                var productId = item.dataset.productId;
                if ( (config.bundleMaxItems > 0 && totalCount>=config.bundleMaxItems)
                  || (stepConfig.max_items > 0 && totalCountInStep>=stepConfig.max_items)
                  || (stepConfig.item_limit > 0 && variantUnits(variantInput.value, currentStep) >= stepConfig.item_limit)
                  || (stepConfig.product_limit > 0 && productUnits(productId, currentStep) >= stepConfig.product_limit) ) {
                  element.setAttribute('disabled', true);
                } else {
                  element.removeAttribute('disabled');
                }
              });
            });

          });

          
          
          //item placeholders
          if (config.showItemsPlaceholder) {
            itemsContainer.querySelectorAll('.item-placeholder').forEach(function(element) {
              element.parentNode.removeChild(element);
            });
            /*
            if (config.bundleMinItems > itemsAdded.length) {
              var placeholder = `
                <div class="bundle-item item-placeholder">
                  <div class="grid">
                    <div class="grid-item one-whole"><div class="image-placeholder"></div></div>
                    <div class="grid-item one-whole"><div class="info-placeholder"></div></div>
                  </div>
                </div>
                `.repeat(config.bundleMaxItems - itemsAdded.length);
                itemsContainer.insertAdjacentHTML('beforeend', placeholder);
            }
            */

            var placeholder = `
            <div class="bundle-item item-placeholder">
              <div class="grid">
                <div class="grid-item one-whole"><div class="image-placeholder"></div></div>
                <div class="grid-item one-whole"><div class="info-placeholder"></div></div>
              </div>
            </div>
            `.repeat(config.bundleMaxItems - itemsAdded.length);
            itemsContainer.insertAdjacentHTML('beforeend', placeholder);
          }


          //disable/enable ADD BUNDLE TO CART button if conditions not meet
          var enableAddBundle = true;
          if (self.stats.incomplete_products_steps.length > 0 || (config.bundleMinItems > 0 && totalCount < config.bundleMinItems)) {
            enableAddBundle = false;
          }
          if (enableAddBundle) {
            container.querySelector('.btn.add').removeAttribute('disabled');
          } else {
            container.querySelector('.btn.add').setAttribute('disabled', true);
          }


          //disable/enable step nav buttons after a step not completed
          if (config.stepsContainer.dataset.navMode == 'step_by_step') {
            var firstStepIncomplete = null;
            if (self.stats.incomplete_products_steps.length>0) {
              firstStepIncomplete = Math.min(...self.stats.incomplete_products_steps);
            }
            config.stepsContainer.querySelectorAll('.nav .step-nav').forEach(function(btn, ix) {
              if (firstStepIncomplete && ix+1 > firstStepIncomplete) {
                btn.setAttribute('disabled', true);
              } else {
                btn.removeAttribute('disabled');
              }
            });
          }


          self.updateProgress();
          
          container.querySelector('.count').innerHTML = totalCount;
          var finalPrice = self.stats.discounted_price ? self.stats.discounted_price : totalPrice;

          container.querySelector('.subtotal .price').innerHTML = `
            ` + (self.stats.discounted_price ? `<span class="retail money">` + $s.formatMoney(self.stats.total) + `</span>` : ``) + `
            <span class="deal money">` + $s.formatMoney(finalPrice) + `</span>
            `;
        }

        self.updateProgress = function() {
          //progress bar UI
          if (self.dataJson.progress_steps.length > 0) {
            var steps = self.dataJson.progress_steps;
            var progressType = self.dataJson.progress_type;
            var currentValue = progressType == 'quantity' ? self.stats.count : self.stats.total/100;
            var values = steps.map((step)=>step.value);
            var maxValue = Math.max(...values);
            var completedCaption = container.querySelector('.progress-completed');
            var caption = container.querySelector('.progress-caption');

            var progressLongValue = container.querySelector('.progress-value');
            var progressBars = container.querySelectorAll('.progress-bar');

            if (self.dataJson.progress_steps_independent) {
              progressBars.forEach(function(progressBar, ix) {
                var progressValue = progressBar.querySelector('.progress-value');
                var barValue = Math.min(currentValue / values[ix] * 100, 100);
                progressValue.style.width = barValue + '%';
                var dot = progressBar.querySelector('.progress-dot');
                if (barValue==100) {
                  dot.classList.add('completed');
                } else {
                  dot.classList.remove('completed');
                }
              });
            } else {
              var barValue = Math.min(currentValue / maxValue * 100, 100);
              progressLongValue.style.width = barValue + '%';
              progressBars.forEach(function(progressBar, ix) {
                progressBar.style.width = (values[ix] - (ix==0 ? 0 : values[ix-1]) ) / maxValue * 100 + '%';
                var dot = progressBar.querySelector('.progress-dot');
                if (values[ix]<=currentValue) {
                  dot.classList.add('completed');
                } else {
                  dot.classList.remove('completed');
                }
              });
            }

            caption.innerHTML = '';
            completedCaption.innerHTML = '';
            var stepCompletedIndex = -1;
            for (var i=0; i<steps.length; i++) {
              var step = steps[i];
              if (currentValue < step.value) {
                //next step
                var diff = step.value - currentValue;
                caption.innerHTML = step.caption_step_in_progress
                  .replace('[CURRENT_VALUE]', (progressType=='quantity' ? currentValue : $s.formatMoney(currentValue * 100)) )
                  .replace('[VALUE_REQUIRED]', (progressType=='quantity' ? diff : $s.formatMoney(diff * 100)) );
                break;
              } else {
                stepCompletedIndex = i;
                completedCaption.innerHTML = step.caption_step_completed;
                self.stats.discount_code = step.discount_code || '';
                if (step.discount_percentage) {
                  self.stats.discounted_price = self.stats.total * (100 - step.discount_percentage) / 100;
                }
              }
            }            

          }
        }


        function init() {
          container.querySelector('.btn.add').addEventListener('click', function() {
            var add = ()=> {
              self.drawFormInputs();
              var data = new FormData();
              container.querySelector('.form-inputs').querySelectorAll('[name]:checked,[name]:not([type="checkbox"]):not([type="radio"])').forEach(x=>data.append(x.name, x.value));
              $s.post({
                url: '/cart/add.js',
                data: data,
                success: function(){
                  $s.addToCartSuccess();
                },
                error: function(response){
                  $s.addToCartFail(response.description);
                }
              })
            }
            
            $s.showLoadingOverlay();

            if (self.stats.discount_code) {
              $s.get({url: '/discount/'+self.stats.discount_code, success: add})
            } else {
              add();
            }
          });

          var expandButton = container.querySelector('.expand-button');

          expandButton.addEventListener('click', function() {
            var panel = container.querySelector('.medium-down--expandable');
            if (this.getAttribute('aria-expanded')=='false') {
              this.setAttribute('aria-expanded', 'true');
              $s.expand([panel]);
            } else {
              this.setAttribute('aria-expanded', 'false');
              $s.collapse([panel]);
            }
          });

          config.items.forEach(function(item) {
            //Update input type number starting value and min="0" attribute
            var a = item.querySelector('.product-card-url');
            a.removeAttribute('href');
            var number = item.querySelector('input[type="number"');
            var variantInput = item.querySelector('input[data-variant-id]');
            var addBtn = item.querySelector('.btn.add');
            var defaultVariantPrice = item.querySelector('product-buttons').dataset.defaultVariantPrice;
            
            item.step = item.closest('[data-step]').dataset.step/1;
            var currentStep = item.step;
            var stepConfig = self.dataJson.products_steps[currentStep-1];

            number.setAttribute('min', '0');
            number.value = 0;
            number.setAttribute('disabled', true);
            if (stepConfig.item_limit) {
              number.setAttribute('max', stepConfig.item_limit);
            }

            //Handle quantity change
            number.addEventListener('change', function(event) {
              var diff = this.value - variantUnits(variantInput.value, currentStep);
              if (diff > 0) {
                self.add(variantInput.value, diff, item);
              } else if (diff < 0) {
                self.remove(variantInput.value, Math.abs(diff), item.step);
              }
            });

            //Handle swatch change
            variantInput.addEventListener('change', function(event) {
              number.value = variantUnits(variantInput.value, currentStep);
              self.updateUI(currentStep);
            });

            //clear existing events and replace button
            var btnDisplay = addBtn.style.display;
            addBtn.outerHTML = `<button type="button" class="btn add" style="display: none">Add - ${defaultVariantPrice}</button>`;
            //update internal reference;
            addBtn = item.querySelector('.btn.add');
            addBtn.style.display = btnDisplay;
            addBtn.addEventListener('click', function() {
              self.add(variantInput.value, 1, item);
              number.value = variantUnits(variantInput.value, currentStep);
              self.updateUI(currentStep);
            });

        
          })

          self.updateUI(1);
        }
        
        init();

        return self;
      })(config);

      this.autoAddDefaultVariants();
    }

    autoAddDefaultVariants() {
      const steps = document.querySelectorAll('.main-grid .step');

      if (steps.length > 1) {
        document.querySelectorAll('.main-grid .step product-variants').forEach((productVariant) => {
          const productSwatch = productVariant.querySelector('.product-swatch');
          const productDropdown = productVariant.querySelector('product-dropdown');
  
          if (!productSwatch && !productDropdown) {
            productVariant.closest('.atc-options-wrapper').querySelector('.btn.add').click();
          }
        });
      }
    }
  }
  customElements.define('bundle-builder', BundleBuilder);
}
